import React from "react";
import s from "./Button.module.scss";
import back from "../../icons/back.svg";

const BackButton = () => {
  return (
    <>
      <button className={s.backBtn} >
        <div className={s.customBorder}>
          <img src={back} alt="back" />
        </div>
      </button>
    </>
  );
};

export default BackButton;
